export default __webpack_public_path__ + "static/media/gajiyabad_img.e601ee71.png";